import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Breadcrumb from "../components/Breadcrumb";

import ProjectService from "../services/ProjectService";
import pettyCashService from "../services/pettyCashService";
import StorageService from "../services/StorageService";
import utility from "../utils/utility";
import { configSettings } from "../config/configSettings";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import MessageDialog from "../components/MessageDialog";
import ReactPaginate from "react-paginate";
import ProjectTeamService from "../services/ProjectTeamService";

export default function PettyCashEntry() {
  const [projects, setProjects] = useState([]);
  const [entries, setEntries] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [entryType, setEntryType] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [editData, setEditData] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState(null);
  const [receiptOld, setReceiptOld] = useState(null);
  // const [projectBalance, setProjectBalance] = useState(0);

  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(0);
  const [totalReceipt, setTotalReceipt] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const { register, reset, watch } = useForm();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [employees, setEmployees] = useState([]);
  const [projectEmployees, setProjectEmployees] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const itemsPerPage = 10;

  // const receiptAmount = useWatch({ control, name: "receiptAmount" }) || 0;
  // const paymentAmount = useWatch({ control, name: "paymentAmount" }) || 0;
  // const balanceAmount = Number(receiptAmount) - Number(paymentAmount);

  const emp = StorageService.loginData();
  const isSuperAdmin = Number(emp.roleId) === 1;
  const isDataAdmin = Number(emp.roleId) === 2 || Number(emp.roleId) === 1;
  const isOtherUser = Number(emp.roleId) !== 2;
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(
    Number(emp.roleId) !== 1 && Number(emp.roleId) !== 2
      ? emp.employeeId
      : ""
  );
  const isAdmin = Number(emp.roleId) === 1 || Number(emp.roleId) === 2;

  const [modalProjectId, setModalProjectId] = useState(null);
  const [modalEmployeeId, setModalEmployeeId] = useState("");

  const [mainProjectSearch, setMainProjectSearch] = useState("");
  const [showMainProjectDropdown, setShowMainProjectDropdown] = useState(false);
  const [modalProjectSearch, setModalProjectSearch] = useState("");
  const [showModalProjectDropdown, setShowModalProjectDropdown] = useState(false);
  const [formRows, setFormRows] = useState([
    {
      pettycashDate: new Date().toISOString().split("T")[0],
      details: "",
      modeOfPayment: "",
      receiptAmount: "",
      paymentAmount: "",
      receiptPreview: null,
      receiptOld: null,
    }
  ]);
  const loadEmployees = async () => {
    const comp = StorageService.activeCompany();
    const res = await pettyCashService.getEmployeesByCompany(comp.companyId);
    setEmployees(res.data);
  };

  const loadProjectEmployees = async (projectId, preserveEmployeeId = false) => {
    try {
      const res = await ProjectTeamService.getByProjectId(projectId, true);
      console.log("PROJECT EMPLOYEES => ", res);

      setProjectEmployees(res || []);
      console.log(res);

      if (!preserveEmployeeId) {
        if (isAdmin) {
          setModalEmployeeId("");
        } else {
          setModalEmployeeId(emp.employeeId);
        }
      }
    } catch (err) {
      console.error(err);
      setProjectEmployees([]);
    }
  };

  const showMessage = (msg, type = "error") => {
    setMessage(msg);
    setMsgType(type);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Petty_Cash,
    showMessage
  );

  const filteredMainProjects = projects.filter((p) => {
    const name = `${p.projectName} ${p.projectCode}`.toLowerCase();
    return name.includes(mainProjectSearch.toLowerCase());
  });

  const filteredModalProjects = projects.filter((p) => {
    const name = `${p.projectName} ${p.projectCode}`.toLowerCase();
    return name.includes(modalProjectSearch.toLowerCase());
  });

  useEffect(() => {
    if (permission) {
      checkView();
    }
  }, [permission]);

  // const calculateProjectBalance = (list, fDate, tDate) => {
  //   if (!Array.isArray(list)) return 0;
  //   let totalReceipt = 0;
  //   let totalPayment = 0;
  //   list.forEach((e) => {
  //     if (fDate && tDate) {
  //       if (e.pettycashDate < fDate || e.pettycashDate > tDate) return;
  //     }
  //     totalReceipt += Number(e.receiptAmount || 0);
  //     totalPayment += Number(e.paymentAmount || 0);
  //   });
  //   return totalReceipt - totalPayment;
  // };


  // useEffect(() => {
  //   if (message) {
  //     const timer = setTimeout(() => setMessage(""), 2000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [message]);

  useEffect(() => {
    if (isDataAdmin) {
      loadEmployees();
    }
  }, []);

  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN (roleId = 1) → ALL PROJECTS BY COMPANY
  //     if (Number(emp.roleId) === 1) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName,
  //       }));
  //     }
  //     // ALL OTHER USERS → ONLY ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };


  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN → ALL COMPANY PROJECTS
      if (Number(emp.roleId) === 1) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          id: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          id: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
        }));
      }

      setProjects(projectsData);
      if (projectsData.length === 1) {
        setSelectedProjectId(projectsData[0].id);

        // for popup
        setModalProjectId(projectsData[0].id);

        // load employees of that project
        await loadProjectEmployees(projectsData[0].id);

        // show project name in search box
        setMainProjectSearch(
          `${projectsData[0].projectName} - ${projectsData[0].projectCode}`
        );

        setModalProjectSearch(
          `${projectsData[0].projectName} - ${projectsData[0].projectCode}`
        );
      }
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };

  const loadPettyCash = async ({
    filterEmployeeId = selectedEmployeeId,
    projectId = selectedProjectId,
    page = currentPage,
  } = {}) => {
    try {
      setLoading(true);

      const comp = StorageService.activeCompany();
      const emp = StorageService.loginData();

      const payload = {
        roleId: Number(emp.roleId),
        employeeId: Number(filterEmployeeId),          // logged-in user
        companyId: comp.companyId,
        filterEmployeeId: filterEmployeeId ? Number(filterEmployeeId) : null,                    // selected from dropdown
        projectId: projectId ? Number(projectId) : null,
        fromDate: fromDate || null,
        toDate: toDate || null,
        page: page,
        type: "exp",
        limit: itemsPerPage
      };
      // alert(payload.companyId);
      const res = await pettyCashService.searchByDate(payload);
      setEntries(res?.data?.data || []);
      setPageCount(res?.data?.pagination?.totalPages || 1);
    } catch (err) {
      console.error(err);
      setEntries([]);
    } finally {
      setLoading(false);
    }
  };

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "-";
  //   const d = new Date(dateStr);
  //   if (isNaN(d)) return dateStr;

  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = String(d.getMonth() + 1).padStart(2, "0");
  //   const year = d.getFullYear();

  //   return `${day}-${month}-${year}`; // DD-MM-YYYY
  // };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return utility.formatDateDDMMMYYYY(dateStr);
  };



  // const loadEntries = async (projectId = null) => {
  //   try {
  //     const emp = StorageService.loginData();
  //     const comp = StorageService.activeCompany();

  //     let response;

  //     // SUPER ADMIN → ALL PETTY CASH
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       response = projectId
  //         ? await pettyCashService.getByProject(projectId, comp.companyId)
  //         : await pettyCashService.getAll(comp.companyId);
  //     }
  //     // EMPLOYEE → ONLY THEIR PETTY CASH
  //     else {
  //       response = projectId
  //         ? await pettyCashService.getByProject(projectId, comp.companyId)
  //         : await pettyCashService.getByEmployee(
  //           emp.employeeId,
  //           comp.companyId
  //         );
  //     }

  //     const list = Array.isArray(response?.data)
  //       ? response.data
  //       : response;

  //     setEntries(list);
  //     // setProjectBalance(calculateProjectBalance(list));
  //   } catch (err) {
  //     console.error(err);
  //     setEntries([]);
  //     // setProjectBalance(0);
  //   }
  // };

  const loadBalance = async (employeeId = null) => {
    const comp = StorageService.activeCompany();

    const targetEmployeeId = employeeId || emp.employeeId;

    const res = await pettyCashService.getEmployeeBalance(
      targetEmployeeId,
      comp.companyId
    );

    setTotalReceipt(res.totalReceipt || 0);
    setTotalPayment(res.totalPayment || 0);
    setBalance(res.balance || 0); // ✅ FIX
  };




  useEffect(() => {
    loadBalance();
  }, []);

  useEffect(() => {
    loadProjects();
  }, []);

  useEffect(() => {
    const emp = StorageService.loginData();

    if (Number(emp.roleId) === 1 || Number(emp.roleId) === 2) {
      loadPettyCash({
        filterEmployeeId: selectedEmployeeId,
        projectId: selectedProjectId,
        page: currentPage,
      });
    } else {
      loadPettyCash({
        filterEmployeeId: emp.employeeId,
        projectId: selectedProjectId,
        page: currentPage,
      });
    }
  }, [selectedEmployeeId, selectedProjectId, currentPage, fromDate, toDate]);


  const addRow = () => {
    setFormRows([
      ...formRows,
      {
        pettycashDate: new Date().toISOString().split("T")[0],
        details: "",
        modeOfPayment: "",
        receiptAmount: "",
        paymentAmount: "",
        receiptPreview: null,
        receiptOld: null,
      }
    ]);
  };

  const removeRow = (index) => {
    const updatedRows = formRows.filter((_, i) => i !== index);
    setFormRows(updatedRows);
  };

  const updateRowField = (index, field, value) => {
    const updatedRows = [...formRows];
    updatedRows[index][field] = value;
    setFormRows(updatedRows);

    if (field === "pettycashDate") {
      // Check if modalEmployeeId is still valid for this changed date
      if (modalEmployeeId && projectEmployees.length > 0) {
        const txDateStr = value ? value.split("T")[0] : "";
        const isStillValid = projectEmployees.some((item) => {
          if (Number(item.employeeId) !== Number(modalEmployeeId)) return false;
          const assignedDateStr = item.assignedDate ? item.assignedDate.split("T")[0] : null;
          const endDateStr = item.endDate ? item.endDate.split("T")[0] : null;
          return (
            txDateStr &&
            assignedDateStr &&
            txDateStr >= assignedDateStr &&
            (!endDateStr || txDateStr <= endDateStr)
          );
        });

        if (!isStillValid && isAdmin) {
          setModalEmployeeId("");
        }
      }
    }
  };

  const handleRowReceiptUpload = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      updateRowField(index, "receiptPreview", reader.result);
    };
  };

  const handleSelect = (id, entry) => {
    setSelectedId(id);
    setSelectedEntry(entry);
  };


  const openAddModal = (type) => {
    setProjectEmployees([]);
    setModalEmployeeId(
      isAdmin ? "" : emp.employeeId
    );
    setEditData(null);
    setSelectedEntry(null);
    setEntryType(type);
    // setModalProjectId(null);
    // setModalProjectSearch("");
    if (projects.length === 1) {
      setModalProjectId(projects[0].id);

      setModalProjectSearch(
        `${projects[0].projectName} - ${projects[0].projectCode}`
      );

      loadProjectEmployees(projects[0].id);
    } else {
      setModalProjectId(null);
      setModalProjectSearch("");
    }
    setShowModalProjectDropdown(false);

    if (type === "Receipt" && isDataAdmin) {
      loadEmployees();   // THIS IS STEP 8
    }
    setFormRows([
      {
        pettycashDate: new Date().toISOString().split("T")[0],
        details: "",
        modeOfPayment: "",
        receiptAmount: "",
        paymentAmount: "",
        receiptPreview: null,
        receiptOld: null,
      }
    ]);
    setShowModal(true);
  };

  const editEntry = async () => {
    if (!selectedId) {
      setMessage("Please select a record to modify.");
      setMsgType("error");
      return;
    }

    const row = entries.find((e) => e.id === selectedId);
    if (!row) {
      setMessage("Selected record not found.");
      setMsgType("error");
      return;
    }

    const emp = StorageService.loginData();
    const today = new Date().toISOString().split("T")[0];

    if (
      Number(emp.roleId) !== 1 &&
      Number(emp.roleId) !== 2 &&
      row.pettycashDate !== today
    ) {
      setMessage("You can only modify today's entry.");
      setMsgType("error");
      return;
    }

    // Determine entry type
    const type =
      Number(row.paymentAmount || 0) > 0
        ? "Payment"
        : "Receipt";
    setEntryType(type);
    setEditData(row);

    if (row.projectId) {
      setModalProjectId(row.projectId);
      const proj = projects.find(p => Number(p.id) === Number(row.projectId));
      if (proj) {
        setModalProjectSearch(`${proj.projectName} - ${proj.projectCode || ""}`);
      } else if (row.projectName) {
        setModalProjectSearch(row.projectName);
      }
      await loadProjectEmployees(row.projectId, true);
    } else {
      setModalProjectId(null);
      setModalProjectSearch("");
      setProjectEmployees([]);
    }

    if (row.employeeId) {
      setModalEmployeeId(row.employeeId);
    }

    const rowDate = row.pettycashDate ? String(row.pettycashDate).split("T")[0] : new Date().toISOString().split("T")[0];

    const resetValues = {
      details: row.Details || "",
      modeOfPayment: row.modeOfPayment || "",
      pettycashDate: rowDate,
      receiptAmount: "",
      paymentAmount: "",
    };

    if (type === "Receipt") {
      resetValues.receiptAmount =
        Number(row.receiptAmount || 0) > 0
          ? Number(row.receiptAmount)
          : "";
    } else {
      resetValues.paymentAmount =
        Number(row.paymentAmount || 0) > 0
          ? Number(row.paymentAmount)
          : "";
    }

    reset(resetValues);

    const rawReceipt = row.receiptURL || null;
    let filename = rawReceipt;
    let previewUrl = null;
    if (rawReceipt) {
      if (rawReceipt.startsWith("http://") || rawReceipt.startsWith("https://")) {
        previewUrl = rawReceipt;
        const parts = rawReceipt.split("/");
        filename = parts[parts.length - 1];
      } else {
        previewUrl = `${configSettings.mediaURL}/get/pettyCash/${rawReceipt}`;
      }
    }

    setFormRows([
      {
        pettycashDate: rowDate,
        details: row.Details || "",
        modeOfPayment: row.modeOfPayment || "",
        receiptAmount: type === "Receipt" ? (Number(row.receiptAmount || 0) > 0 ? Number(row.receiptAmount) : "") : "",
        paymentAmount: type === "Payment" ? (Number(row.paymentAmount || 0) > 0 ? Number(row.paymentAmount) : "") : "",
        receiptPreview: previewUrl,
        receiptOld: filename,
      }
    ]);

    setShowModal(true);
  };

  const handleMakePayment = () => {
    setMessage("");
    setMsgType("error");

    // if (!selectedProjectId) {
    //   setMessage("Select the project to make payment");
    //   setMsgType("info");
    //   return;
    // }

    openAddModal("Payment");
  };



  //   useEffect(() => {
  //   setSelectedEmployeeId(emp.employeeId);
  // }, []);

  // useEffect(() => {
  //   if (selectedEmployeeId && selectedProjectId) {
  //     loadFilteredEntries(selectedEmployeeId, selectedProjectId);
  //   }
  // }, [selectedEmployeeId, selectedProjectId]);


  const handleSave = async () => {
    if (!can("canAdd")) {
      showMessage("No permission");
      return;
    }

    if (!modalProjectId) {
      setMessage("Please select project");
      setMsgType("error");
      return;
    }
    if (!modalEmployeeId) {
      setMessage("Please select employee");
      setMsgType("error");
      return;
    }

    const dateObj = new Date();
    const todayStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

    // Validate each row
    for (let i = 0; i < formRows.length; i++) {
      const row = formRows[i];
      const selectedDateStr = row.pettycashDate;

      if (!selectedDateStr) {
        setMessage(`Please select date for row ${i + 1}`);
        setMsgType("error");
        return;
      }

      if (selectedDateStr > todayStr) {
        setMessage(`Future dates are not allowed (row ${i + 1})`);
        setMsgType("error");
        return;
      }

      if (!isAdmin && selectedDateStr !== todayStr) {
        setMessage(`Normal users can only assign today's date (row ${i + 1})`);
        setMsgType("error");
        return;
      }

      if (!row.details || row.details.trim() === "") {
        setMessage(`Please enter details for row ${i + 1}`);
        setMsgType("error");
        return;
      }

      if (!row.modeOfPayment) {
        setMessage(`Please select payment mode for row ${i + 1}`);
        setMsgType("error");
        return;
      }

      if (
        entryType === "Payment" &&
        (!row.paymentAmount || Number(row.paymentAmount) <= 0)
      ) {
        setMessage(`Please enter payment amount for row ${i + 1}`);
        setMsgType("error");
        return;
      }

      if (
        entryType === "Receipt" &&
        (!row.receiptAmount || Number(row.receiptAmount) <= 0)
      ) {
        setMessage(`Please enter receipt amount for row ${i + 1}`);
        setMsgType("error");
        return;
      }

      // Check employee assignment date range
      const empAssignment = projectEmployees.find(e => Number(e.employeeId) === Number(modalEmployeeId));
      if (empAssignment) {
        const assignedDateStr = empAssignment.assignedDate ? empAssignment.assignedDate.split("T")[0] : null;
        const endDateStr = empAssignment.endDate ? empAssignment.endDate.split("T")[0] : null;
        
        if (assignedDateStr && selectedDateStr < assignedDateStr) {
          setMessage(`Employee ${empAssignment.firstName || ''} ${empAssignment.lastName || ''} is assigned from ${utility.formatDateDDMMMYYYY(assignedDateStr)}. Date ${utility.formatDateDDMMMYYYY(selectedDateStr)} is not allowed (row ${i + 1}).`);
          setMsgType("error");
          return;
        }
        if (endDateStr && selectedDateStr > endDateStr) {
          setMessage(`Employee ${empAssignment.firstName || ''} ${empAssignment.lastName || ''} assignment ended on ${utility.formatDateDDMMMYYYY(endDateStr)}. Date ${utility.formatDateDDMMMYYYY(selectedDateStr)} is not allowed (row ${i + 1}).`);
          setMsgType("error");
          return;
        }
      }
    }

    try {
      const comp = StorageService.activeCompany();

      for (const row of formRows) {
        await pettyCashService.create({
          companyId: Number(comp.companyId),
          entryType: "PETTY_CASH",
          projectId: Number(modalProjectId),
          Details: row.details,
          modeOfPayment: row.modeOfPayment,
          pettycashDate: row.pettycashDate,
          status: "Active",
          receiptURL: row.receiptPreview,
          createdBy: emp.employeeId,
          employeeId: Number(modalEmployeeId),
          receiptAmount: entryType === "Receipt" ? Number(row.receiptAmount) : null,
          paymentAmount: entryType === "Payment" ? Number(row.paymentAmount) : null,
        });
      }

      setMessage("Saved successfully");
      setMsgType("success");

      await loadPettyCash({
        filterEmployeeId: isAdmin ? selectedEmployeeId : emp.employeeId,
        projectId: selectedProjectId || null,
        page: currentPage,
      });
      await loadBalance();
      setShowModal(false);
    } catch (err) {
      console.error(err);
      setMessage(err?.response?.data?.message || err?.message || "Error saving entry");
      setMsgType("error");
    }
  };

  // const applyFilters = async (empId, projectId) => {
  //   const comp = StorageService.activeCompany();

  //   try {
  //     setLoading(true);

  //     // ✅ ADMIN + NO EMPLOYEE SELECTED → COMPANY DATA
  //     if (isAdmin && empId == null) {
  //       const data = projectId
  //         ? await pettyCashService.getByProject(projectId, comp.companyId)
  //         : await pettyCashService.getAll(comp.companyId);

  //       setEntries(data);
  //       return;
  //     }

  //     // ✅ EMPLOYEE ONLY
  //     if (empId && !projectId) {
  //       const data = await pettyCashService.getByEmployee(empId, comp.companyId);
  //       setEntries(data);
  //       return;
  //     }

  //     // ✅ EMPLOYEE + PROJECT
  //     if (empId && projectId) {
  //       const data = await pettyCashService.getByEmployeeAndProject(
  //         empId,
  //         projectId,
  //         comp.companyId
  //       );
  //       setEntries(data);
  //     }

  //   } catch (err) {
  //     console.error(err);
  //     setEntries([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (e) => {
      // check if clicked outside dropdown container
      if (!e.target.closest(".main-project-dropdown-container")) {
        setShowMainProjectDropdown(false);
      }
      if (!e.target.closest(".modal-project-dropdown-container")) {
        setShowModalProjectDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  const handleUpdate = async () => {
    if (!can("canModify")) {
      showMessage("No permission");
      return;
    }

    if (!modalProjectId) {
      setMessage("Please select project");
      setMsgType("error");
      return;
    }

    const dateObj = new Date();
    const todayStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

    const row = formRows[0];
    const selectedDateStr = row.pettycashDate;

    if (!selectedDateStr) {
      setMessage("Please select date");
      setMsgType("error");
      return;
    }

    if (selectedDateStr > todayStr) {
      setMessage("Future dates are not allowed");
      setMsgType("error");
      return;
    }

    if (!isAdmin && selectedDateStr !== todayStr) {
      setMessage("Normal users can only assign today's date");
      setMsgType("error");
      return;
    }

    if (!row.details || row.details.trim() === "") {
      setMessage("Please enter details");
      setMsgType("error");
      return;
    }

    if (!row.modeOfPayment) {
      setMessage("Please select payment mode");
      setMsgType("error");
      return;
    }

    if (
      entryType === "Payment" &&
      (!row.paymentAmount || Number(row.paymentAmount) <= 0)
    ) {
      setMessage("Please enter payment amount");
      setMsgType("error");
      return;
    }

    if (
      entryType === "Receipt" &&
      (!row.receiptAmount || Number(row.receiptAmount) <= 0)
    ) {
      setMessage("Please enter receipt amount");
      setMsgType("error");
      return;
    }

    if (!modalEmployeeId) {
      setMessage("Please select employee");
      setMsgType("error");
      return;
    }

    // Check employee assignment date range
    const empAssignment = projectEmployees.find(e => Number(e.employeeId) === Number(modalEmployeeId));
    if (empAssignment) {
      const assignedDateStr = empAssignment.assignedDate ? empAssignment.assignedDate.split("T")[0] : null;
      const endDateStr = empAssignment.endDate ? empAssignment.endDate.split("T")[0] : null;
      
      if (assignedDateStr && selectedDateStr < assignedDateStr) {
        setMessage(`Employee ${empAssignment.firstName || ''} ${empAssignment.lastName || ''} is assigned from ${utility.formatDateDDMMMYYYY(assignedDateStr)}. Date ${utility.formatDateDDMMMYYYY(selectedDateStr)} is not allowed.`);
        setMsgType("error");
        return;
      }
      if (endDateStr && selectedDateStr > endDateStr) {
        setMessage(`Employee ${empAssignment.firstName || ''} ${empAssignment.lastName || ''} assignment ended on ${utility.formatDateDDMMMYYYY(endDateStr)}. Date ${utility.formatDateDDMMMYYYY(selectedDateStr)} is not allowed.`);
        setMsgType("error");
        return;
      }
    }

    try {
      await pettyCashService.update(editData.id, {
        entryType: "PETTY_CASH",
        Details: row.details,
        modeOfPayment: row.modeOfPayment,
        receiptAmount: entryType === "Receipt" ? Number(row.receiptAmount) : null,
        paymentAmount: entryType === "Payment" ? Number(row.paymentAmount) : null,
        pettycashDate: row.pettycashDate,
        projectId: Number(modalProjectId),
        employeeId: Number(modalEmployeeId),
        receiptURL: (row.receiptPreview && row.receiptPreview.startsWith("data:"))
          ? row.receiptPreview
          : (row.receiptPreview ? row.receiptOld : null),
        receiptURLOld: (row.receiptPreview && row.receiptPreview.startsWith("data:"))
          ? row.receiptOld
          : (row.receiptPreview ? row.receiptOld : null),
        updatedBy: StorageService.loginData().employeeId,
      });

      setMessage("Updated successfully");
      setMsgType("success");

      await loadPettyCash({
        filterEmployeeId: isAdmin ? selectedEmployeeId : emp.employeeId,
        projectId: selectedProjectId || null,
        page: currentPage,
      });

      await loadBalance();
      setShowModal(false);
      setSelectedEntry(null);
    } catch (err) {
      console.error(err);
      setMessage(err?.response?.data?.message || err?.message || "Error updating entry");
      setMsgType("error");
    }
  };

  const toggleStatus = async (entry) => {
    if (!can("canModify")) {
      setMessage("No permission");
      return;
    }
    const newStatus = entry.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Change status to ${newStatus}?`)) return;

    try {
      await pettyCashService.updateStatus(entry.id);
      setMessage("Status updated successfully");
      setMsgType("success");
      await loadPettyCash({
        filterEmployeeId:
          isAdmin ? selectedEmployeeId : emp.employeeId,
        projectId: selectedProjectId || null,
        page: currentPage,
      });
    } catch {
      setMessage("Failed to update status");
      setMsgType("error");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("You need to delete this record?")) return;

    try {
      await pettyCashService.delete(id);
      setMessage("Deleted successfully");
      setMsgType("success");
      await loadPettyCash({
        filterEmployeeId: isAdmin ? selectedEmployeeId : emp.employeeId,
        projectId: selectedProjectId || null,
        page: currentPage,
      });
      await loadBalance();
    } catch (err) {
      console.error(err);
      setMessage("Error deleting entry");
      setMsgType("error");
    }
  };

  const pettycashDateValue = formRows[0]?.pettycashDate;

  const getFilteredProjectEmployees = () => {
    const txDateStr = pettycashDateValue ? String(pettycashDateValue).split("T")[0] : null;

    const activeList = (projectEmployees || []).filter((item) => {
      const assignedDateStr = item.assignedDate ? String(item.assignedDate).split("T")[0] : null;
      const endDateStr = item.endDate ? String(item.endDate).split("T")[0] : null;

      return (
        txDateStr &&
        assignedDateStr &&
        txDateStr >= assignedDateStr &&
        (!endDateStr || txDateStr <= endDateStr)
      );
    });

    // De-duplicate by employeeId
    const uniqueEmployees = [];
    const seenIds = new Set();
    for (const empItem of activeList) {
      if (!seenIds.has(Number(empItem.employeeId))) {
        seenIds.add(Number(empItem.employeeId));
        uniqueEmployees.push(empItem);
      }
    }

    // If editData is present (modifying) and modalEmployeeId is set, ensure the currently selected employee is visible in dropdown
    if (editData && modalEmployeeId && !seenIds.has(Number(modalEmployeeId))) {
      const existingEmp = (projectEmployees || []).find(e => Number(e.employeeId) === Number(modalEmployeeId)) 
        || (editData.employeeName ? { employeeId: Number(modalEmployeeId), firstName: editData.employeeName, lastName: "" } : null);
      if (existingEmp) {
        uniqueEmployees.push(existingEmp);
      }
    }

    return uniqueEmployees;
  };

  return (
    <>
      <Breadcrumb pageTitle="Petty Cash Entry" secondTitle="Cash" />
      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="row">
        <div className="card p-3 mb-3 d-flex gap-3 align-items-end flex-row">

          {/* EMPLOYEE – ONLY FOR RECEIPT (DATA / SUPER ADMIN) */}
          <div>
            <label className="form-label">Paid by</label>

            {isAdmin ? (
              /* DATA ADMIN / SUPER ADMIN → DROPDOWN */
              <select
                className="form-select"
                value={selectedEmployeeId}
                onChange={(e) => {
                  const empId = e.target.value || null;
                  setSelectedEmployeeId(empId);
                  setCurrentPage(1);

                  // ✅ UPDATE BALANCE
                  loadBalance(empId);
                }}
              >
                <option value="">All Employee</option>

                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
              </select>
            ) : (
              /* NORMAL USER → READ ONLY */
              <input
                type="text"
                className="form-control"
                value={`${emp.firstName} ${emp.lastName}`}
                disabled
              />
            )}
          </div>

          {/* PROJECT */}


          <div style={{ width: "220px" }}>
            <label className="form-label">Total Receipt</label>
            <input
              type="text"
              className="form-control"
              value={`₹ ${Number(totalReceipt || 0).toFixed(3)}`}
              disabled
            />
          </div>

          <div style={{ width: "220px" }}>
            <label className="form-label">Total Payment</label>
            <input
              type="text"
              className="form-control"
              value={`₹ ${Number(totalPayment || 0).toFixed(3)}`}
              disabled
            />
          </div>

          <div style={{ width: "220px" }}>
            <label className="form-label">Balance Amount</label>
            <input
              type="text"
              className="form-control fw-bold"
              value={`₹ ${Number(balance || 0).toFixed(3)}`}
              disabled
            />
          </div>

        </div>

        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-end flex-wrap">

            <div className="d-flex align-items-end gap-3">

              {/* <h5 className="mb-1">Petty Cash</h5> */}

              <div
                className="position-relative main-project-dropdown-container"
                style={{ width: "280px" }}
              >
                <label className="form-label mb-1">Project</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Project..."
                  value={
                    selectedProjectId
                      ? projects.find((p) => Number(p.id) === Number(selectedProjectId))
                        ?.projectName +
                      " - " +
                      projects.find((p) => Number(p.id) === Number(selectedProjectId))
                        ?.projectCode
                      : mainProjectSearch
                  }
                  onFocus={() => setShowMainProjectDropdown(true)}
                  onChange={(e) => {
                    setMainProjectSearch(e.target.value);
                    setShowMainProjectDropdown(true);
                    setSelectedProjectId("");
                  }}
                />

                {showMainProjectDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      background: "#fff",
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      zIndex: 1050,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    <div
                      className="p-2 border-bottom"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedProjectId("");
                        setMainProjectSearch("");
                        setShowMainProjectDropdown(false);
                        setCurrentPage(1);
                      }}
                    >
                      All Projects
                    </div>

                    {(mainProjectSearch ? filteredMainProjects : projects).map((p) => (
                      <div
                        key={p.id}
                        className="p-2 border-bottom"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedProjectId(p.id);
                          setMainProjectSearch("");
                          setShowMainProjectDropdown(false);
                          setCurrentPage(1);
                        }}
                      >
                        {p.projectName} - {p.projectCode}
                      </div>
                    ))}

                    {(mainProjectSearch ? filteredMainProjects : projects).length === 0 && (
                      <div className="p-2 text-muted">
                        No projects found
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div>
                <label className="form-label mb-1">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>

              <div>
                <label className="form-label mb-1">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>

            </div>
            <div className="d-flex gap-2">
              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  disabled={!selectedId}
                  onClick={editEntry}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}

              {can("canAdd") && (
                <button
                  className="btn btn-info"
                  onClick={handleMakePayment}
                >
                  Make Payment
                </button>
              )}
            </div>

          </div>

          <div className="card-body">
            {/* {message && <div className={`alert alert-${msgType} py-2`}>{message}</div>} */}
            <div
              style={{
                maxHeight: "65vh",
                overflowY: "auto",
                overflowX: "auto",
                width: "100%",
              }}
            >
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Date</th>
                    <th>Paid by</th>
                    <th>Project</th>
                    <th>Details </th>
                    <th>Mode Of Payment</th>
                    {/* <th>Amount</th> */}
                    <th>Payment Amount</th>
                    <th>Receipt URL</th>
                    {can("canReject") && <th>Action</th>}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={can("canReject") ? 9 : 8} className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </td>
                    </tr>
                  ) : entries.length ? (
                    entries.map((e, idx) => (
                      <tr
                        key={e.id}
                        className={selectedId === e.id ? "table-active" : ""}
                        onClick={() => setSelectedEntry(e)}
                      >
                        <td className="text-center">
                          <input
                            type="radio"
                            name="pettyCashSelect"
                            checked={selectedId === e.id}
                            onChange={() => handleSelect(e.id, e)}
                            onClick={(evt) => evt.stopPropagation()}
                          />
                        </td>
                        <td>{formatDate(e.pettycashDate)}</td>
                        <td>{e.employeeName}</td>
                        <td>{e.projectName || "-"}</td>
                        <td>{e.Details}</td>
                        <td>{e.modeOfPayment}</td>
                        {/* <td>{e.receiptAmount != null
                          ? Number(e.receiptAmount).toFixed(3)
                          : "-"}</td> */}
                        <td>{e.paymentAmount != null
                          ? Number(e.paymentAmount).toFixed(3)
                          : "-"}</td>
                        <td>
                          {e.receiptURL ? (
                            <a
                              href={`${configSettings.mediaURL}/get/pettyCash/${e.receiptURL}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View
                            </a>
                          ) : (
                            "-"
                          )}
                        </td>
                        {can("canReject") && (
                          <td className="text-center">
                            {(() => {
                              const isDeletable = isAdmin || e.pettycashDate === `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`;
                              return (
                                <button
                                  className="btn btn-danger btn-sm"
                                  title={isDeletable ? "Delete" : "Only today's records can be deleted"}
                                  style={{
                                    opacity: isDeletable ? 1 : 0.4,
                                    cursor: isDeletable ? "pointer" : "not-allowed"
                                  }}
                                  disabled={!isDeletable}
                                  onClick={(evt) => {
                                    evt.stopPropagation();
                                    if (isDeletable) {
                                      handleDelete(e.id);
                                    }
                                  }}
                                >
                                  <i className="ti ti-trash"></i>
                                </button>
                              );
                            })()}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={can("canReject") ? 9 : 8} className="text-center text-muted">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <ReactPaginate
              forcePage={Math.max(0, currentPage - 1)}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={pageCount}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        </div>

        {showModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              zIndex: 1027,
            }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                width: "80%",
                transform: "translate(-50%, -50%)",
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <h5>{editData ? "Update Cash Entry" : "Add Cash Entry"}</h5>

              {/* {message && (
                <div className={`alert alert-${msgType} py-2`}>{message}</div>
              )} */}

              <div className="row mb-3">

                <div className="col-md-6  position-relative modal-project-dropdown-container">
                  <label className="form-label">Select Project</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search project..."
                    // value={
                    //   modalProjectId
                    //     ? projects.find(p => Number(p.id) === Number(modalProjectId))?.projectName +
                    //     " - " +
                    //     projects.find(p => Number(p.id) === Number(modalProjectId))?.projectCode
                    //     : modalProjectSearch
                    // }
                    value={
                      modalProjectId
                        ? (() => {
                            const proj = projects.find(
                              p => Number(p.id) === Number(modalProjectId)
                            );
                            if (proj) {
                              return `${proj.projectName} - ${proj.projectCode || ""}`;
                            }
                            return modalProjectSearch;
                          })()
                        : modalProjectSearch
                    }
                    onFocus={() => setShowModalProjectDropdown(true)}
                    onChange={(e) => {
                      setModalProjectSearch(e.target.value);
                      setShowModalProjectDropdown(true);
                      setModalProjectId(null);
                    }}
                  />

                  {showModalProjectDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                        background: "#fff",
                        border: "1px solid #ccc",
                        zIndex: 1000,
                      }}
                    >
                      {(modalProjectSearch ? filteredModalProjects : projects).map((p) => (
                        <div
                          key={p.id}
                          style={{ padding: "8px", cursor: "pointer" }}
                          onClick={() => {
                            setModalProjectId(p.id);
                            setModalProjectSearch("");
                            setShowModalProjectDropdown(false);

                            loadProjectEmployees(p.id);
                          }}
                        >
                          {p.projectName} - {p.projectCode}
                        </div>
                      ))}

                      {(modalProjectSearch ? filteredModalProjects : projects).length === 0 && (
                        <div className="p-2 text-muted">No projects found</div>
                      )}
                    </div>
                  )}
                </div>
                <div className="col-md-6 ">
                  <label className="form-label">
                    Employee
                  </label>

                  {isAdmin ? (
                    <select
                      className="form-select"
                      value={modalEmployeeId || ""}
                      onChange={(e) =>
                        setModalEmployeeId(e.target.value)
                      }
                    >
                      <option value="">Select Employee</option>

                      {getFilteredProjectEmployees().map((item) => (
                        <option
                          key={item.employeeId}
                          value={item.employeeId}
                        >
                          {item.firstName} {item.lastName}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      value={`${emp.firstName} ${emp.lastName}`}
                      disabled
                    />
                  )}
                </div>
              </div>
              <div
                style={{
                  maxHeight: "350px",
                  overflowY: formRows.length > 2 ? "scroll" : "auto",
                  overflowX: "auto",
                  marginTop: "15px",
                  paddingRight: "5px"
                }}
              >
                <table className="table table-bordered align-middle" style={{ width: "100%", minWidth: "800px" }}>
                  <thead>
                    <tr>
                      <th style={{ width: "15%" }}>Date</th>
                      <th style={{ width: "25%" }}>Details <span className="text-danger">*</span></th>
                      <th style={{ width: "15%" }}>Payment Mode <span className="text-danger">*</span></th>
                      <th style={{ width: "15%" }}>
                        {entryType === "Receipt" ? "Receipt Amount" : <>Payment Amount <span className="text-danger">*</span></>}
                      </th>
                      <th style={{ width: "20%" }}>Receipt</th>
                      {!editData && <th style={{ width: "10%" }}>Action</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {formRows.map((row, idx) => (
                      <tr key={idx}>
                        {/* DATE */}
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            value={row.pettycashDate}
                            onChange={(e) => updateRowField(idx, "pettycashDate", e.target.value)}
                            disabled={!isAdmin}
                            max={new Date().toLocaleDateString('en-CA')}
                          />
                        </td>

                        {/* DETAILS */}
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={row.details}
                            onChange={(e) => updateRowField(idx, "details", e.target.value)}
                          />
                        </td>

                        {/* PAYMENT MODE */}
                        <td>
                          <select
                            className="form-select"
                            value={row.modeOfPayment}
                            onChange={(e) => updateRowField(idx, "modeOfPayment", e.target.value)}
                          >
                            <option value="">Select</option>
                            <option value="UPI">UPI</option>
                            <option value="Bank">Bank</option>
                            <option value="Cash">Cash</option>
                          </select>
                        </td>

                        {/* AMOUNT */}
                        <td>
                          {entryType === "Receipt" ? (
                            <input
                              type="number"
                              step="0.001"
                              min="0"
                              className="form-control"
                              value={row.receiptAmount}
                              onChange={(e) => updateRowField(idx, "receiptAmount", e.target.value)}
                              onBlur={(e) => {
                                if (e.target.value !== "") {
                                  const val = parseFloat(e.target.value).toFixed(3);
                                  updateRowField(idx, "receiptAmount", val);
                                }
                              }}
                            />
                          ) : (
                            <input
                              type="number"
                              step="0.001"
                              min="0"
                              className="form-control"
                              value={row.paymentAmount}
                              onChange={(e) => updateRowField(idx, "paymentAmount", e.target.value)}
                              onBlur={(e) => {
                                if (e.target.value !== "") {
                                  const val = parseFloat(e.target.value).toFixed(3);
                                  updateRowField(idx, "paymentAmount", val);
                                }
                              }}
                            />
                          )}
                        </td>

                        {/* UPLOAD RECEIPT */}
                        <td>
                          <div className="d-flex flex-column gap-1">
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              accept="image/*,.pdf"
                              onChange={(e) => handleRowReceiptUpload(idx, e)}
                            />
                            {row.receiptPreview && (
                              <div className="d-flex align-items-center gap-1 mt-1">
                                {(row.receiptPreview.startsWith("data:image/") ||
                                  (row.receiptPreview.indexOf("data:") < 0 &&
                                    /\.(jpe?g|png|gif|webp|bmp)$/i.test(row.receiptPreview))) ? (
                                  <a
                                    href={row.receiptPreview}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={row.receiptPreview}
                                      alt="receipt"
                                      width="40"
                                      height="30"
                                      style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                                    />
                                  </a>
                                ) : (
                                  <a
                                    href={row.receiptPreview || (row.receiptOld ? `${configSettings.mediaURL}/get/pettyCash/${row.receiptOld}` : "#")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="badge bg-info text-decoration-none"
                                    style={{ cursor: "pointer" }}
                                  >
                                    View File
                                  </a>
                                )}
                                <button
                                  type="button"
                                  className="btn btn-sm text-danger p-0"
                                  onClick={() => updateRowField(idx, "receiptPreview", null)}
                                >
                                  <i className="ti ti-trash"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </td>

                        {/* ACTIONS */}
                        {!editData && (
                          <td>
                            <div className="d-flex gap-1">
                              <button
                                type="button"
                                className="btn btn-success btn-sm p-1 d-flex align-items-center justify-content-center"
                                style={{ width: "28px", height: "28px" }}
                                onClick={addRow}
                              >
                                <i className="ti ti-plus" style={{ fontSize: "16px" }}></i>
                              </button>
                              {formRows.length > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm p-1 d-flex align-items-center justify-content-center"
                                  style={{ width: "28px", height: "28px" }}
                                  onClick={() => removeRow(idx)}
                                >
                                  <i className="ti ti-minus" style={{ fontSize: "16px" }}></i>
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ACTION BUTTONS */}
              <div className="d-flex justify-content-end gap-2 mt-3">
                {editData ? (
                  can("canModify") && (
                    <button className="btn btn-primary" onClick={handleUpdate}>
                      Update
                    </button>
                  )
                ) : (
                  can("canAdd") && (
                    <button className="btn btn-primary" onClick={handleSave}>
                      Save
                    </button>
                  )
                )}

                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  <i className="ti ti-cancel me-1"></i> Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
